import { ScrollToContent } from './ScrollToContent/ScrollToContent';
import { getCurrentYear, getYearsInService } from './Date/DateFunctions';

export { getCurrentYear, getYearsInService, ScrollToContent };
